import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("nav", {
    staticClass: "main-menu"
  }, [_vm.isMenuMobile ? [_c(VMenu, {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c(VIcon, _vm._g({
          staticClass: "mobile-menu"
        }, on), [_vm._v("fa-bars")])];
      }
    }], null, false, 1906605204)
  }, [_c(VList, [_c(VListItem, {
    on: {
      click: function click($event) {
        return _vm.goHome();
      }
    }
  }, [_c(VListItemContent, [_c("span", {
    staticClass: "mobile-menu-item"
  }, [_vm._v("HOME")])])], 1), _vm._l(_vm.mainMenus, function (m) {
    return _c(VListItem, {
      key: m.id,
      on: {
        click: function click($event) {
          return _vm.mobileMenuAction(m);
        }
      }
    }, [_c(VListItemContent, [_c("span", {
      staticClass: "mobile-menu-item"
    }, [_vm._v(" " + _vm._s(m.id_menu != 999 ? m.name.replace(/[^\w^\s]/g, "").toUpperCase() : "RETURN TO WEBSITE") + " ")])])], 1);
  })], 2)], 1)] : [_c("div", {
    staticClass: "menu-logo-img",
    on: {
      click: function click($event) {
        return _vm.goHome();
      }
    }
  }), _c("div", {
    attrs: {
      id: "textual-menus"
    }
  }, [_vm.loaded && _vm.$whitelabel.tenantType == _vm.tenantType.OWNER && _vm.mainMenus.length < 1 ? [_c("div", {
    staticClass: "cursor--pointer",
    attrs: {
      id: "menu-home-brand"
    },
    on: {
      click: function click($event) {
        return _vm.goHome();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$whitelabel.brand) + " ")])] : _vm._l(_vm.mainMenus, function (menuItem) {
    return _c("menu-item", {
      key: menuItem.id_menu,
      attrs: {
        menuItemData: menuItem
      }
    });
  })], 2)]], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };